goog.provide("shadow.js.shim.module$src$svg$artwork$approvals_svg");
goog.provide("module$shadow_js_shim_module$src$svg$artwork$approvals_svg");
shadow.js.shim.module$src$svg$artwork$approvals_svg = shadow.js.nativeProvides["src/svg/artwork/approvals.svg"] = shadow$bridge("src/svg/artwork/approvals.svg");
module$shadow_js_shim_module$src$svg$artwork$approvals_svg.default = shadow.js.shim.module$src$svg$artwork$approvals_svg;
